// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".scroll-overFlow{overflow:scroll}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/financialTransactions/modals/financialTransactionDetails.scss"],"names":[],"mappings":"AAAA,iBACE,eAAgB","file":"financialTransactionDetails.scss","sourcesContent":[".scroll-overFlow{\n  overflow: scroll;\n}"]}]);
// Exports
module.exports = exports;
